export default __webpack_public_path__ + "media/zurb/img/legacy/strike/instructions-4-fcd5d920465b6a3098aa2e93ec2fd45d.jpg";